import { useForm, UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  createIngredientSchema,
  CreateIngredientFormData,
  getDefaultIngredientFormValues,
} from "./forms/schema";

/**
 * Shared hook for setting up the ingredient form
 * Used by both create and edit dialogs
 */
export function useIngredientForm(
  defaultValues?: Partial<CreateIngredientFormData>,
): UseFormReturn<CreateIngredientFormData> {
  return useForm<CreateIngredientFormData>({
    resolver: zodResolver(createIngredientSchema),
    defaultValues: getDefaultIngredientFormValues(defaultValues),
  });
}
